import React, { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';

const NetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    // Handler untuk ketika koneksi online
    const handleOnline = () => {
      setIsOnline(true);
      toast.success('Koneksi internet tersedia kembali', {
        duration: 3000,
        position: 'top-right'
      });
    };

    // Handler untuk ketika koneksi offline
    const handleOffline = () => {
      setIsOnline(false);
      toast.error('Tidak ada koneksi internet', {
        duration: 5000,
        position: 'top-right',
        icon: '🔌'
      });
    };

    // Menambahkan event listener
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Cleanup event listener
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  // Jika offline, tampilkan banner peringatan
  if (!isOnline) {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          backgroundColor: '#f44336',
          color: 'white',
          textAlign: 'center',
          padding: '8px',
          zIndex: 9999,
        }}
      >
        Tidak ada koneksi internet. Beberapa fitur mungkin tidak berfungsi.
      </div>
    );
  }

  // Jika online, tidak perlu menampilkan apa-apa
  return null;
};

export default NetworkStatus;